module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-lg-3 centered"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 jumbotron"
  }, [_c('h1', [_vm._v("SurveyJS + VueJS bolierplate")]), _vm._v(" "), _c('p', [_vm._v("\n      We have been developing and supporting our library for several years. We helped hundreds of companies across many industries. We carefully reviewed every survey and form from our customerscustomers to add the necessary functionality that covers all the popular scenarios.\n      We are confident, that you can build almost everything, that popular cloud services offer, using SurveyJS library. You can extend our SurveyJS Library and change its behavior.\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b30fd52c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 376
// module chunks = 1